export default __webpack_public_path__ + "media/PowerPlatform.b696e352.svg";